import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from "react-redux";
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import { Elements } from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";

import { fetchTenantSettings } from "../actions/tenant";

import Header from "./Header";
import Footer from "./Footer";
import ErrorBoundary from "./ErrorBoundary";
import Stations from "./Stations";
import Book from "./Book";
import TrainList from "./TrainList";
import Travelers from "./Travelers";
import Train from "./Train";
import Steps from "./Steps";
import Confirmation from "./Confirmation";
import MyBookings from "./MyBookings";
import StripeConnect from "./StripeConnect";
import WagonDev from "./WagonDev";

export default function App() {
    const [stripePromise, setStripePromise] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        // Load per-tenant settings (incl. fee config) once for the whole app.
        dispatch(fetchTenantSettings());
    }, [dispatch]);

    useEffect(() => {
        // Always the platform's public key. The checkout form creates its own
        // Stripe.js instance bound to the tenant's connected account once the
        // payment intent (a direct charge on that account) exists.
        const platformStripeKey = process.env.MIX_STRIPE_PUBLIC_KEY;
        if (platformStripeKey) {
            setStripePromise(loadStripe(platformStripeKey));
        }
    }, []);

    return (
        <>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <Router>
                        <Header />
                        <Steps />
                        <ErrorBoundary>
                        <Switch>
                            <Route exact path={["/", "/trains"]} component={TrainList} />
                            <Route exact path="/dev/wagon/:wagonType?" component={WagonDev} />
                            <Route path="/trains/:id/seats" component={Train} />
                            <Route path="/trains/:id/book">
                                <Elements stripe={stripePromise}>
                                    <Book />
                                </Elements>
                            </Route>
                            <Route path="/trains/:id/travelers" component={Travelers} />
                            <Route path="/trains/:id/station" component={Stations} />
                            <Route path="/confirmation" component={Confirmation} />
                            <Route path="/mina-bokningar" component={MyBookings} />
                            <Route path="/stripe-connect" component={StripeConnect} />
                        </Switch>
                        </ErrorBoundary>
                </Router>
            </div>
            <Footer />
        </>
    )
}
